import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_rgba_0_0_0_50 = setTheme(({ theme }) => `background-color: ${theme.colors.color_rgba_0_0_0_50}`);
